<div class="modal-header">
    <h4 class="modal-title">{{ "international_projects.countries.sort_projects" | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body">
    <div class="mb-2">
        <adaa-form-dropdown-multi
            [setDefaultValue]="selectedProjects()"
            [options]="projects()"
            [label]="'international_projects.projects.title' | translate"
            [maxSelect]="5"
            (inputChanges)="selectedProjects.set($event ?? [])"
        />
    </div>

    @if (selectedProjects().length === 5) {
        <adaa-draggable-sort-list [showNumber]="true" [list]="sortableProjects()" (listChanged)="sortedProjects.set($event)" />
    } @else {
        <h6 class="text-center fw-bold text-info mt-2">{{ "international_projects.countries.sort_projects_warning" | translate }}</h6>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
</div>
